export default {"src":"/_next/static/media/help-icon.24f8579d.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};